import React from "react";
import styles from "./FormInput.module.scss";

export default function FormInput({ input, register, control }) {
  const { component, id, label, instructions, containerStyles } = input;

  // Create React component with props
  const InputComponent = React.createElement(component, {
    ...input.props,
    register,
    control,
  });

  return (
    <div className={`${styles.container}`} style={{ ...containerStyles }}>
      <label className={styles.label}>
        <span className={styles.labelText}>{label}</span>
        <span className={styles.instructions}>{instructions}</span>
        {InputComponent}
      </label>
    </div>
  );
}
